import { Router, NavigationExtras } from '@angular/router';

/**
 * Navigate with query params preservation (merge)
 * This utility function automatically preserves existing query params when navigating
 * 
 * @param router - Router instance
 * @param commands - Navigation commands (same as router.navigate)
 * @param extras - Optional navigation extras (queryParamsHandling will be set to 'merge' automatically)
 * 
 * @example
 * // Simple navigation with query params preservation
 * navigateWithQueryParams(this.router, ['/users', 'edit', userId]);
 * 
 * @example
 * // Navigation with additional query params
 * navigateWithQueryParams(this.router, ['/users', 'edit', userId], {
 *   queryParams: { mode: 'edit' }
 * });
 */
export function navigateWithQueryParams(
  router: Router,
  commands: any[],
  extras?: NavigationExtras
): Promise<boolean> {
  return router.navigate(commands, {
    ...extras,
    queryParamsHandling: 'merge',
  });
}

